import { useMemo } from 'react';
import { When } from 'react-if';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button, Menu, MenuItem, MenuList } from '@zep/ui';
import { Colors } from '@zep/ui-tokens';
import { ZEPSymbolLogo } from '@zep/web-components';
import { StoreFilterType } from '../../../../types';
import { CaretDownIcon } from '../../../icons';
import S from './StoreFilter.module.scss';
const StoreFilter = ({
  filter,
  onFilterChange,
  totalCount,
  isPriceHidden
}: StoreFilterProps) => {
  const currentPriceTypeLabelKey = useMemo(() => {
    switch (filter?.priceType) {
      case 'free':
        return 'store_asset_free';
      case 'charged':
        return 'store_asset_priced';
      default:
        return 'store_asset_all_price';
    }
  }, [filter?.priceType]);
  const orderLabelKey = useMemo(() => {
    switch (filter?.order) {
      case 'popular':
        return 'store_order_popular';
      default:
        return 'store_order_recent';
    }
  }, [filter?.order]);
  const {
    query
  } = useRouter();
  const {
    t
  } = useTranslation(['store']);
  const isOfficialFilterOn = query?.assetType === 'official';
  const isApp = query?.type === 'app' || query?.type === 'game';
  return <div className={S.store_filter} data-sentry-component="StoreFilter" data-sentry-source-file="StoreFilter.tsx">
      <strong>{t('store:store_assets_counts', {
        count: totalCount
      })}</strong>
      <div className={S.item_filter_wrapper}>
        {!isPriceHidden && <Menu className={S.price_type_dropdown} menuListPlacement={'bottom-start'} useFloatingOverlay={false} button={<Button variant={'white'} size={'sm'} transparent={true} rightSlot={<CaretDownIcon width={16} height={16} />}>
                {t(`store:${currentPriceTypeLabelKey}`)}
              </Button>}>
            <MenuList>
              <MenuItem onClick={() => onFilterChange('priceType', 'all')}>
                {t('store:store_asset_all_price')}
              </MenuItem>
              <MenuItem onClick={() => onFilterChange('priceType', 'free')}>
                {t('store:store_asset_free')}
              </MenuItem>
              <MenuItem onClick={() => onFilterChange('priceType', 'charged')}>
                {t('store:store_asset_priced')}
              </MenuItem>
            </MenuList>
          </Menu>}

        <Menu className={S.order_dropdown} menuListPlacement={'bottom-start'} useFloatingOverlay={false} button={<Button variant={'white'} size={'sm'} transparent={true} rightSlot={<CaretDownIcon width={16} height={16} />}>
              {t(`store:${orderLabelKey}`)}
            </Button>} data-sentry-element="Menu" data-sentry-source-file="StoreFilter.tsx">
          <MenuList data-sentry-element="MenuList" data-sentry-source-file="StoreFilter.tsx">
            <MenuItem onClick={() => onFilterChange('order', 'latest')} data-sentry-element="MenuItem" data-sentry-source-file="StoreFilter.tsx">
              {t('store:store_order_recent')}
            </MenuItem>
            <MenuItem onClick={() => onFilterChange('order', 'popular')} data-sentry-element="MenuItem" data-sentry-source-file="StoreFilter.tsx">
              {t('store:store_order_popular')}
            </MenuItem>
          </MenuList>
        </Menu>

        <When condition={!isApp} data-sentry-element="When" data-sentry-source-file="StoreFilter.tsx">
          <Button size="xs" leftSlot={<div style={{
          transform: isOfficialFilterOn ? 'rotate(360deg)' : 'rotate(0)',
          transition: 'transform 0.7s ease'
        }}>
                <ZEPSymbolLogo width={20} height={20} color={isOfficialFilterOn ? Colors.White : Colors.Gray400} fill={isOfficialFilterOn ? Colors.PrimaryDefault : Colors.White} />
              </div>} onClick={() => onFilterChange('assetType', `${!isOfficialFilterOn ? 'official' : 'normal'}`)} variant={isOfficialFilterOn ? 'primary' : 'sub'} rounded data-sentry-element="Button" data-sentry-source-file="StoreFilter.tsx">
            {t('store:store_asset_official')}
          </Button>
        </When>
      </div>
    </div>;
};
export default StoreFilter;
type StoreFilterProps = {
  totalCount: number;
  filter?: StoreFilterType;
  onFilterChange: (key: keyof StoreFilterType, value: string) => void;
  isPriceHidden?: boolean;
};